import { Injectable } from "@angular/core";
import { BaseApiService } from "../shared/_base.api.service";
import { FilterType } from "../../utils/types/shared/_filter.type";
import { PagedApiResponse } from "../../utils/types/shared/_paged-api-response.type";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { OperatorMapper } from "../../utils/mappers/operator/operator.mapper";
import { OPERATOR_ENDPOINTS } from "../../components/mediaManager/admon/operator/operator-endpoints";
import { Operator } from "../../utils/types/operator/operator.type";
import { OperatorCompany } from "../../utils/types/admon/OperatorCompany.type";
import { HttpParams } from "@angular/common/http";

@Injectable()
export class OperatorService extends BaseApiService<Operator> {
    model = Operator;
    mapper = new OperatorMapper();
    apiEndPoint: any = OPERATOR_ENDPOINTS;

    createOperatorShortCodes(
        data: OperatorCompany,
        companyId: number,
        operatorId: number
    ): Observable<boolean> {
        return this.http
            .post<boolean>(
                this.apiEndPoint.shortCode
                    .replace("{companyId}", companyId.toString())
                    .replace("{operatorId}", operatorId.toString()),
                data
            )
            .pipe(
                map((res) => {
                    return res;
                })
            );
    }

    create(data: Operator): Observable<boolean> {
        return this.http.post<boolean>(this.apiEndPoint.list, data).pipe(
            map((res) => {
                return res;
            })
        );
    }
    getList(filter?: FilterType): Observable<PagedApiResponse<Operator>> {
        let params = new HttpParams();
        params = params.append("limit", filter.limit);
        params = params.append("offset", filter.offset);

        return this.http.get(this.apiEndPoint.list, { params }).pipe(
            map((res) => {
                return this.sharedMapper.mapPagedApiResponse(
                    res,
                    this.mapper.mapList,
                    this.model
                );
            })
        );
    }

    getListByStatus(
        state: number,
        filter?: FilterType
    ): Observable<PagedApiResponse<Operator>> {
        return this.http
            .get(
                this.apiEndPoint.listStatus.replace(
                    "{status}",
                    state.toString()
                )
            )
            .pipe(
                map((res) => {
                    return this.sharedMapper.mapPagedApiResponse(
                        res,
                        this.mapper.mapList,
                        this.model
                    );
                })
            );
    }

    update(data: Operator): Observable<boolean> {
        const { id } = data;
        const endpoint = this.apiEndPoint.item.replace("{id}", id.toString());
        return this.http.put<boolean>(endpoint, data);
    }

    updateOperatorShortCodes(
        data: OperatorCompany,
        companyId: number,
        operatorId: number
    ): Observable<boolean> {
        // const { id } = data;
        return this.http
            .put<boolean>(
                this.apiEndPoint.shortCode
                    .replace("{companyId}", companyId.toString())
                    .replace("{operatorId}", operatorId.toString()),
                data
            )
            .pipe(
                map((res) => {
                    return res;
                })
            );
    }

    delete(id: number): Observable<boolean> {
        const endpoint = this.apiEndPoint.item.replace("{id}", id.toString());
        return this.http.delete<boolean>(endpoint);
    }

    deleteOperatorShortCodes(
        companyId: number,
        operatorId: number
    ): Observable<boolean> {
        const endpoint = this.apiEndPoint.shortCode
            .replace("{companyId}", companyId.toString())
            .replace("{operatorId}", operatorId.toString());
        return this.http.delete<boolean>(endpoint);
    }
}
